<div class="content">

    <button mat-flat-button color="primary" (click)="createNewTicket()">{{'New ticket' | translate}}</button>

    <table mat-table [dataSource]="arrayTicket"
        class="mat-elevation-z8 cmat-add-border">

    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->

    <ng-container matColumnDef="CREATION_DATE">
        <th mat-header-cell *matHeaderCellDef> {{'Date' | translate}} </th>
        <td mat-cell *matCellDef="let element"> {{getDate(element)}} </td>
    </ng-container>

    <ng-container matColumnDef="CONTACT">
        <th mat-header-cell *matHeaderCellDef> {{'Origine' | translate}} </th>
        <td mat-cell *matCellDef="let element">{{element.CONTACT}}</td>
    </ng-container>

    <ng-container matColumnDef="DESCRIPTION">
        <th style="width: 40%;" mat-header-cell *matHeaderCellDef> {{'Description' | translate}} </th>
        <td mat-cell *matCellDef="let element">
            <div style="white-space: pre-line; text-align: start;">{{element.DESCRIPTION}}</div>
        </td>
    </ng-container>

    <ng-container matColumnDef="PERSON_IN_CHARGE">
        <th mat-header-cell *matHeaderCellDef> {{'Personne en charge' | translate}} </th>
        <td mat-cell *matCellDef="let element"> {{element.PERSON_IN_CHARGE}} </td>
    </ng-container>

    <ng-container matColumnDef="STATUS">
        <th mat-header-cell *matHeaderCellDef> {{'État' | translate}} </th>
        <td mat-cell *matCellDef="let element"> {{getStatus(element) | translate}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row
        [ngClass]="getTrBackgroundClass(row)"
        *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
</div>
